import {
  getInLocalStorageByKey,
  setInLocalStorage,
} from 'src/utils/storageManager';
import { LocalStorageKey } from 'src/config/constants';

export const updateLocalStorageUserID = (userId: number | null) => {
  setInLocalStorage(LocalStorageKey.FAMILY_USER_ID, userId);
};
export const getLocalStorageUserID = (): number | null => {
  return getInLocalStorageByKey(LocalStorageKey.FAMILY_USER_ID);
};

export const addLocalStorageBabzWon = (xpWon: number) => {
  setInLocalStorage(LocalStorageKey.BABZ_WON, getLocalStorageBabzWon() + xpWon);
};
export const getLocalStorageBabzWon = (): number => {
  return getInLocalStorageByKey(LocalStorageKey.BABZ_WON) || 0;
};
export const resetLocalStorageBabzWon = () => {
  setInLocalStorage(LocalStorageKey.BABZ_WON, 0);
};
